// learning_management_frontend/src/index.js
if (!window.location.pathname.startsWith('/api/')) {
  import('./indexApp').then(({ default: runApp }) => {
    runApp();
  });
}


